import { render } from "./PlpFacetRefinementsWrapper.vue?vue&type=template&id=6d08eb56"
import script from "./PlpFacetRefinementsWrapper.vue?vue&type=script&lang=js"
export * from "./PlpFacetRefinementsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__